<template>
  <ShopIFrame :config="config" />
</template>

<script>
import ShopIFrame from "../../components/ShopIFrame/ShopIFrame.vue";

export default {
  name: "app",
  components: {
    ShopIFrame
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
